<template>
    <!-- Breadcrumb Section Start -->
    <section class="breadscrumb-section pt-0">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-12">
                    <div class="breadscrumb-contain">
                        <h2>{{ $t('Change password') }}</h2>
                        <nav>
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item active">{{ $t('Change password') }}</li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                        <i class="fa-solid fa-house"></i>
                                    </router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- log in section start -->
    <section class="log-in-section section-b-space forgot-section">
        <div class="container-fluid-lg w-100">
            <div class="d-flex align-items-center justify-content-center h-100">
                <div class="log-in-box">
                    <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show"
                         :class="{ 'show' : error !== null }" role="alert">
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                                @click="error = null"></button>
                        <strong>{{ error }}</strong>
                    </div>
                    <div class="input-box">
                        <form class="row g-4" @submit.prevent="create">

                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="password" class="form-control" id="old_password"
                                           :placeholder="$t('Current Password')" v-model="item.old_password" required>
                                    <label for="old_password">{{ $t('Current Password') }}</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="password" class="form-control" id="password"
                                           :placeholder="$t('New Password')" v-model="item.password" required>
                                    <label for="password">{{ $t('New Password') }}</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-floating theme-form-floating log-in-form">
                                    <input type="password" class="form-control" id="confirmPassword"
                                           :placeholder="$t('Repeat the new password')" v-model="item.confirmPassword"
                                           required>
                                    <label for="confirmPassword">{{ $t('Repeat the new password') }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <button class="btn btn-animation w-100" type="submit">{{
                                        $t('Change password')
                                    }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- log in section end -->
</template>



<script setup>
import { ref } from 'vue'
import { Head, useHead } from "@vueuse/head"
const count = ref(0)
useHead({
    title: 'تغيير كلمة المرور',
})
</script>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

import Utility from '../../utility'
import {Bootstrap5Pagination} from "laravel-vue-pagination";

export default {
    inject: ['auth'],
    components: {
        Bootstrap5Pagination,
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if (newVal === false) {
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    data() {
        return {
            show_old_password: false,
            show_password: false,
            show_confirmPassword: false,
            error: null,
            item: {},
        }
    },
    created(){

        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }

    },
    methods: {
        create() {
            const id = toast.info(this.$t('Adding content...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;

            axios.post('change_password',
                this.item
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });


                that.error = null;

                this.$router.push({name: 'home', params: { lang : that.$i18n.locale } });

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {

                    that.error = error.response.data.message;

                }
            });

        },
    }
}
</script>
